import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTrackingSnippetStatus as GetTrackingSnippetStatusQuery,
    GetTrackingSnippetStatus_analyticsStatus as AnalyticsStatus,
} from 'nutshell-graphql-types';

import GET_TRACKING_SNIPPET_STATUS from '../queries/get-tracking-snippet-status.graphql';

export const useGetTrackingSnippetStatus = (): {
    trackingSnippetStatus: AnalyticsStatus | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetTrackingSnippetStatusQuery,
        Record<any, any>
    >(GET_TRACKING_SNIPPET_STATUS, {
        fetchPolicy: 'cache-and-network',
    });

    const analyticsStatus = data ? data.analyticsStatus : null;

    return {
        trackingSnippetStatus: analyticsStatus,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
